var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcedure2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6605 43.4858V36.3187L34.2671 43.4858H39.6605ZM44.5109 46.3816V49.567C45.066 49.8324 45.802 49.9652 46.719 49.9652C46.719 50.1341 46.719 50.3754 46.719 50.6891C46.719 51.0028 46.6707 51.4372 46.5742 51.9922H37.1991C37.1991 51.7992 37.1991 51.5216 37.1991 51.1597C37.1991 50.7736 37.2594 50.3754 37.38 49.9652C38.1523 49.8445 38.7193 49.6394 39.0813 49.3498C39.4674 49.0602 39.6605 48.5414 39.6605 47.7933V46.3816H31.5523C30.9972 45.5611 30.6353 44.7648 30.4663 43.9926L41.6513 28.4639H44.5109V43.4858H47.7325C47.8773 44.1615 47.9497 44.7407 47.9497 45.2233C47.9497 45.6818 47.9256 46.0679 47.8773 46.3816H44.5109Z",
    fill: "#CE0E2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.873,
    cy: 40.0784,
    r: 38.5686,
    stroke: "#CE0E2D",
    strokeWidth: 2.36134
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedure2);
export default __webpack_public_path__ + "static/media/procedure (2).49a9535960e25dbfb52e1a440bf5502e.svg";
export { ForwardRef as ReactComponent };